// app.js and react-app.js are two independently-bundled IIFEs (separate
// `vite build` invocations, see vite.config.ts / vite.react.config.ts) -
// every "shared" module each one imports gets its own private, duplicated
// closure. There is no runtime link between two separately-built bundles,
// even when compiled from identical TypeScript source, so plain
// module-level `let`/`Set`/`Map` state can never actually coordinate
// vanilla and React code - each side silently talks to its own copy.
//
// window is the one thing genuinely shared between them (both scripts run
// in the same document) - every cross-bundle bus (lockBus, themeState,
// stateBus, toastBus, dialogBus, albumPickerBus) stores its state here
// instead. Whichever bundle's script runs first creates the entry; the
// other finds and reuses it, in either load order.
export function getSharedState<T>(key: string, init: () => T): T {
  const w = window as unknown as Record<string, T>;
  if (!(key in w)) {
    w[key] = init();
  }
  return w[key];
}
